import {Component, forwardRef, Input} from '@angular/core';
import {DictionariesService} from "../../../service";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";
import {PageOkcm} from "../../../../../../api/build";


@Component({
  selector: 'app-dict-qref-okcm',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefOkcmViewComponent),
    multi: true
  }],
  template: `
    <div [class]="ngClassProps">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="kokcm3"
                         name="ncm"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['ncm','kokcm3']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          <b> {{ item.kokcm3 }} </b>
          {{ item.ncm }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <div style="white-space: normal">
            <b> {{ item.kokcm3 }} </b>
            {{ item.ncm }}
          </div>
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefOkcmViewComponent extends ViewDictionaryBase<PageOkcm> {
  @Input() ngClassProps = 'mb-3 col-6 pl-0 pr-0';
  getDictionary = this.dictSrv.getQrefOkcmList();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
